// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Zamknij',
  error: () => 'Błąd',
  warn: () => 'Ostrzeżenie',
  info: () => 'Informacja',
  confirmation: () => 'Potwierdzenie',
  progressIndeterminate: () => 'W toku',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Między ' + p['FROM_SECTION'] + ' a ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nie znaleziono zgodnej sekcji.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Aby wybrać wartość, proszę nacisnąć klawisz Enter.',
  indexer_touchInstructionText: () =>
    'Aby przełączyć się do trybu gestów, proszę 2x stuknąć i przytrzymać, a następnie - aby dostosować wartość - przeciągnąć w górę lub w dół.',
  inputPassword_show: () => 'Pokaż hasło',
  inputPassword_hide: () => 'Ukryj hasło',
  inputPassword_hidden: () => 'Hasło ukryte',
  formControl_clear: () => 'Wyczyść',
  formControl_loading: () => 'Ładowanie',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Przekroczono maksymalną długość ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Pozostało znaków: ' + p['CHARACTER_COUNT'] + '.',
  formControl_requiredMessageDetail: () => 'Proszę wprowadzić wartość.',
  select_requiredMessageDetail: () => 'Proszę wybrać wartość.',
  select_noMatchesFound: () => 'Nie znaleziono zgodnych.',
  select_oneMatchFound: () => 'Znaleziono zgodnych: 1',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Znaleziono zgodnych: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Znaleziono zgodnych: ' + p['TOTAL_SIZE'] + ' lub więcej',
  selectMultiple_selectedValues: () => 'Wybrane wartości',
  selectMultiple_showSelectedValues: () => 'Pokaż tylko wybrane wartości.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' wybrane wartości.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Aby usunąć wybraną wartość, proszę nacisnąć klawisz Backspace lub Delete',
  selectMultiple_apply: () => 'Zastosuj',
  selectMultiple_back: () => 'Wstecz',
  selector_selected: () => 'Pole wyboru zaznaczone',
  selector_unselected: () => 'Pole wyboru niezaznaczone',
  userAssistance_learnMore: () => 'Dalsze informacje',
  userAssistance_required: () => 'Wymagane',
  filePicker_singleFileUploadError: () => 'Proszę wysyłać po jednym pliku',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nie można wysłać plików typu ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nie można wysłać plików typu ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'nieznany',
  filePicker_dropzonePrimaryText: () => 'Przeciąganie i upuszczanie',
  filePicker_dropzoneSecondaryText: () => 'Proszę wybrać plik lub go tutaj przeciągnąć',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Proszę wybrać pliki lub je tutaj przeciągnąć',
  filePicker_addFiles: () => 'Dodaj pliki',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Zwiększ',
  inputNumber_decrease: () => 'Zmniejsz',
  inputNumber_converterParseError: () => 'Proszę wprowadzić liczbę.',
  noData_message: () => 'Brak elementów do wyświetlenia',
  message_navigationFromMessagesRegion: () =>
    'Wchodzenie do obszaru komunikatów. Aby się cofnąć do elementu, na którym znajdował się fokus, proszę nacisnąć klawisz F6.',
  message_navigationToMessagesRegion: () =>
    'W obszarze komunikatów są nowe komunikaty. Aby przejść do nich, proszę nacisnąć klawisz F6.',
  messageToast_allMessagesClosed: () => 'Wszystkie wyskakujące powiadomienia są zamknięte.',
  expandableList_groupCollapse: () => 'Zwinięte',
  expandableList_groupExpand: () => 'Rozwinięte',
  expandableList_expandCollapseInstructionText: () =>
    'Do rozwijania i zwijania proszę używać klawiszy ze strzałkami',
  list_suggestion: () => 'Sugestia',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etap ' + p['currentStep'] + ' z ' + p['numberOfSteps'],
  train_current: () => 'Bieżące',
  train_visited: () => 'Odwiedzone',
  train_not_visited: () => 'Nieodwiedzone',
  train_message_type: () => 'Typ wiadomości',
  viz_drillable: () => 'Możliwe do drążenia',
  dataVisualization_stateSelected: () => 'Wybrane',
  dataVisualization_stateUnselected: () => 'Niewybrane',
  dataVisualization_noData: () => 'Brak danych do wyświetlenia'
};
export default bundle;
